import { GLOB032 } from "./Isilog.popins";
import { IsiPlInstanceScreen } from "./Isilog/PresentationLogic/IsiPlInstanceScreen";
import { iws_GetPageName } from "./tools.ts";
import { AvailableScreenList, IsiCallerType } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlSuggest";
import { iws_IsiSuggestUpdateShownValue } from "./Isilog/Core/IsiSuggest";
import { IsiPlSuggest } from "./Isilog/PresentationLogic/IsiPlSuggest";
import { modifWaitStatus } from "./IsiPage.ts";
import { IsiPlMergeModel } from "./Isilog/PresentationLogic/IsiPlMergeModel";
import { IIsiDtoPlMergeModelMergeMailPjResult, IIsiDtoPlMergeModelRequest } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMergeModel";
import { IIsiUIFlowResultGeneric } from "./Isilog/Core/IIsiUIFlowResultGeneric";


/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 12/10/2006
'- Description : Sauvegarde du controle passe en parametre dans le champ cache "ihdLastFocusedCtrl".
'-				 Permet de renseigne le serveur sur le dernier ctrl ayant eu le focus.
'-----------------------------------------------------------------------------------------*/
export function iws_SaveFocusedCtrl(id) {

    // On ne sauvegarde pas les focus sur les DIV formulaire ou entete (on passera directement l'ID 
    // du controle concerne).
    if (id == DIV_FORMULAIRE || id == DIV_ENTETE) {
        return;
    }

    // Recherche du champ cache qui contiendra l'ID du controle qui a le focus.
    var oHdCtrl = <HTMLInputElement>document.getElementById("ihdLastFocusedCtrl");

    if (oHdCtrl) {
        oHdCtrl.value = id;
    }
}

window.iws_SaveFocusedCtrl = iws_SaveFocusedCtrl;

/*-- CREATION -------------------------------------------------------------------------------------------------
'- Auteur      : CEGO
'- Date        : 20/12/2010
'- Description : [DYSFCT:0000040679] : Actions pour lequelles on propose la confirmation des modifications ou non.
'-- MODIFICATION '---------------------------------------------------------------------------------------------
'- Auteur      : JBUI
'- Date        : 25/02/2013
'- Description : [DEV:64103] : Réalisation d'action, prise en compte des modifications.
'-------------------------------------------------------------------------------------------------------------
     <entry mat="LBRI" date="11/01/2016" task="DEV116632">Modification</entry>
'-------------------------------------------------------------------------------------------------------------
     <entry mat="TCLE" date="08/03/2018" task="T141366">ajout de actionChangerInfoCnx</entry>
'-------------------------------------------------------------------------------------------------------------*/
export function iws_ActionHasConfirmMaster(codeAction) {

    var bRet = (codeAction == "actionEditerSQL"
        || codeAction == "actionEscaladeMoins"
        || codeAction == "actionEscaladePlus"
        || codeAction == "actionACloturer"
        || codeAction == "actionChgmtAffect"
        || codeAction == "actionEditer"
        || codeAction == "actionPublierGantt"
        || codeAction == "actionPublier"
        || codeAction == "actionNouvelleVersion"
        || codeAction == "actionChangerInfoCnx"
        || screenCore.menuManager.IsValideImplicite(codeAction));

    return bRet;
}
window.iws_ActionHasConfirmMaster = iws_ActionHasConfirmMaster;

export function iws_ActionHasConfirmDetail(codeAction) {
    /// <summary>
    /// Spécification des actions qui veulent afficher la validation des modifications.
    /// </summary>

    // YLAR 16/04/2013 : Correction la propriété propname n'est pas disponible sous firefox
    var sPageName = iws_GetPageName();

    // [GELA] - [16.01.2013] - [ANA:PB0006893] - Lorsque l'on realise des actions, Les modifications en cours sur le dossier sont perdues (DYSF40444).   
    var bRet = ((codeAction == "actionRealize"
        || codeAction == "actionDerealize"
        || iws_ActionHasConfirmDetail_overridable(codeAction))
        && sPageName != "LIST002");

    return bRet;
}
window.iws_ActionHasConfirmDetail = iws_ActionHasConfirmDetail;

export function iws_RegisterLastAction(name) {
    /// <summary>
    ///     Sauve l'action qui vient d'être exécutée
    /// </summary>
    var ihdLastActionName = <HTMLInputElement>document.getElementById("ihdLastActionName");
    if (ihdLastActionName) {
        ihdLastActionName.value = name;
    }
}
window.iws_RegisterLastAction = iws_RegisterLastAction;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : VLEB
'- Date        : 08/02/2006
'- Description : Appelle la popup pour selectionner une instance lors de d'un ajout par textconnexe.
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : GELA
'- Date        : 13/06/2007
'- Description : Ajout du parametre sTraitement a la place d'une valeur en dur.
'- HMLA - RWD : changement de la taille de la fenetre.
'- MODIFICATION 
'- CLEM 12/05/2016 T118252 POPIN
'-----------------------------------------------------------------------------------------*/
export function getInstanceForModif(objectId: string, traitement: string, callbackTreatment: any) {

    // JSOU 06/04/2011 Dev 41548 Redimensionnement de la GLOB

    GLOB032().open({
        sID: objectId,
        sTraitement: traitement
    }, {
        callback: {
            func: function (returnCodes) {
                if (returnCodes) {
                    const codeRetour = returnCodes[0];

                    (document.getElementById('ihdItemClickForInstanceVT') as HTMLInputElement).value = codeRetour;

                    if (codeRetour === "ERR") {
                        //L'utilisateur n'a pas les droits d'ajout.
                        uiCore.showErrorMessage(uiCore.getMessage("frmscriptHeadBloc", "PasAjout").IsiLabel);
                    } else {
                        uiCore.setSubmit(true);
                    }
                } else {
                    // L'utilisateur a annule, on stoppe donc le traitement.
                    uiCore.setSubmit(false);
                }
                return uiCore.getSubmit();
            },
            callback: callbackTreatment
        },
        resizeToFitContent: uiCore.isTouchMode()
    });

}

export function bPropTr(evt, sIDObjTxt, sIDObj, imgButtonID): Promise<boolean> {
    // appel a la fonction surchargee
    //Retourne la valeur pour bloquer ou non le traitement. (false pour bloquer).
    //CDES T118252
    uiCore.setSubmit(true);
    return uiCore.currentScreen.onProperty(evt, sIDObjTxt, sIDObj, imgButtonID);
}

window.bPropTr = bPropTr;


/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : VLEB
'- Date        : 08/02/2006
'- Description : Fonction appelee lors de la perte de focus sur le champ texte d'un 
'				 IsiTextConnexe.
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : SMAR
'- Date        : 08/06/2006
'- Description : Ajout du traitement pour le cas on la cle est renseignee et que l'on veut 
'				 la valeur texte.
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : ABUR
'- Date        : 12/06/2006
'- Description : Correction du DYFCT 13161 : On passe la bonne information en fonction de
'				 de l'action souhaitee.
'-----------------------------------------------------------------------------------------*/
/******MODIFICATION DU NOM D'UNE FONCTION********************************
'   Auteur      :   ARAN                                                '
'   Date        :   17/10/2008                                          '
'   Ancien Nom  :   iws_AfterIsiCtrlConnexeChange                       '
'   Nouveau Nom :   iACnxChg                                            '
'   Description :   [DEV-20675] Optimisation de la taille des page      '
*************************************************************************/
function iACnxChg(sIDObj: string, sIDObjText: string, sIDObjValue: string, event: any): boolean {
    let retour: boolean;
    let waitAsync = false;
    uiCore.log("iACnxChg sIDObj=" + sIDObj + ", sIDObjText=" + sIDObjText + ", sIDObjValue=" + sIDObjValue); // DYSF  75143

    // Recuperation du controle
    const ctrl = iwsAllCtrls.getCtrl(sIDObj);
    ctrl.razCnxInstanceState();

    // MAXB Si le control à un onchange spécifique on éffectue quand même le onchange (retour = false)
    if (window.xmlUserSettings.IsDefaultValueTriggerOnChange() && !ctrl.hasSpecificOnChange) {
        // PerfAjaxAsyncCtrlConnexe PB0018366
        //uiCore.log("iACnxChg : blocage car lance suite a la mise a jour du controle par val-def");
        retour = true;
    } else {
        waitAsync = true;

        const eventIsiOnChangeInProgress = new CustomEvent("isiOnChangeInProgress")
        ctrl.getInputElement().dispatchEvent(eventIsiOnChangeInProgress);

        uiCore.cnxChangingValue = true;

        getConnexeInfo(ctrl, sIDObjText, sIDObjValue, event).then((result: boolean) => {
            const eventIsiAfterOnChange = new CustomEvent("isiAfterOnChange", {
                detail: event?.detail
            });

            ctrl.getInputElement().dispatchEvent(eventIsiAfterOnChange);

            uiCore.cnxChangingValue = false;
            
            return result;
        }).catch(() => {
            uiCore.cnxChangingValue = false;
        });
    }
    uiCore.log("appel iws_IsiSuggestUpdateShownValue par icnxChg:" + ctrl.fullId);

    iws_IsiSuggestUpdateShownValue(ctrl.fullId, true);
    if (!waitAsync) {
        return retour;
    }  
}
window.iACnxChg = iACnxChg

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : VLEB
'- Date        : 08/02/2006
'- Description : Fonction chargeant les données relative aux connexes.
------------------------------------------------------------------------------------------*/

async function getConnexeInfo(ctrl: IwsControle, sIDObjText: string, sIDObjValue: string, event: any) {
    let result = false;
    let valeurAction = "";
    let waitAsync = false;
    // Variable qui contiendra la valeur ou le text en fonction du type d'action
    let valeurControl;
    // Pointeur sur le controle fullid

    const propChange = iwsAllCtrls.tryGetPropChange(ctrl.id);

    const ctrlTxtFast = (document.getElementById(ctrl.clientId + "_" + TEXTBOX_FAST_ID) as HTMLInputElement);
    const ctrlOtherValue = (document.getElementById(ctrl.clientId + "_" + HIDDEN_OTHERVALUE) as HTMLInputElement);

    if (propChange) {
        if (propChange == "TEXT") {
            valeurAction = GET_VALUE;
        } else {
            switch (propChange) {
                // Dsyf. 72759 - JREV - 10/03/2016  - Si un champ change à cause d'une val def
                case "NULLVAL":
                    valeurAction = "";
                    if (ctrlTxtFast) {
                        ctrlTxtFast.value = "";
                    }
                    if (ctrlOtherValue) {
                        ctrlOtherValue.value = "";
                    }
                    break;
                case "VAL":
                    valeurAction = GET_TEXT;
                    // LBRI - 2011.07.05 - [DYSF:37658] : si la valeur a change, on l'indique pour que la vue doublons puisse s'afficher.
                    window.gbCtrlTextIsChanging = true;
                    break;
                case "VALANDTEXT":
                    // Si on on deja renseigne la valeur et le text
                    window.gbCtrlTextIsChanging = true;
                    valeurAction = "";
                    break;
                // JBES - 26/09/2006 - Dysf 15438. Lors du remplissage du quicksearch par  
                case "VALANDTEXTID":
                    // le TextId on ne doit pas effectuer de verification. La valeur est deja renseignee
                    // et n'est pas soumise aux filtres par cette methode de recherche.
                    valeurAction = "";
                    window.gbCtrlTextIsChanging = true;
                    window.gsLastKeyPressed = -1;
                    break;
            }
        }
        // On vide ensuite cette propriete
        iwsAllCtrls.trySetPropChange(ctrl.id, "");
    } else {
        valeurAction = GET_VALUE;
    }

    // ABUR - 12/06/2006 - DYSFCT 13161
    // Si on souhaite recuperer la valeur	
    if (valeurAction == GET_VALUE) {
        // Alors on recupere le text
        valeurControl = (document.getElementById(sIDObjText) as HTMLInputElement).value;
        // Sinon, si on souhaite recuperer le text
    } else if (valeurAction == GET_TEXT) {
        // Alors on recupere la valeur
        valeurControl = (document.getElementById(sIDObjValue) as HTMLInputElement).value;
    }

    if (valeurAction !== "") {

        //uiCore.log("iACnxChg sAction=" + sAction); // DYSF  75143
        if (!ctrl.alreadyLoadedText) {
            waitAsync = true;
            const plSuggest = new IsiPlSuggest();
            const sLinkedCtrlFilter = iwsAllCtrls.getDictLinkedCtrl(ctrl.filter, window.TYPE_FILTER);
            const res = await plSuggest.GetConnexeValues(ctrl.id, ctrl.mainCtrlId, valeurAction, valeurControl, sLinkedCtrlFilter, ctrl.ctrlType);
            if (res.data) {
                if (res.data === "PropertyNotAllowed") {
                    result = true;
                } else {
                    await IsiAsyncCtrlConnexeHandleResult(res.data, event?.detail);
                    result = false;
                }
            } else {
                result = false;
            }
        }
    } else {

        //uiCore.log("iACnxChg appel de iURc"); // DYSF  75143
        await iURc(iwsAllCtrls.getCtrlByFullId(sIDObjText), event?.detail);

    }
    if (!waitAsync) {
        result = false;
    }
    return result;
}

/**
 * Lance la fusion d'un modèle, dans le cas d'une PJ de mail en attente du fusion
 */
export async function mergeMailPj(args, me) {
    const pl = new IsiPlMergeModel();
    const dto: IIsiDtoPlMergeModelRequest = {
        codeDocole: args.item.recordKey,
        returnType: 'IIsiDtoAttachedFileItem'
    };

    const flowResult: IIsiUIFlowResultGeneric<IIsiDtoPlMergeModelMergeMailPjResult> = await pl.mergeMailPj(dto)
    if (flowResult.reponse.erreur) {
        args.canContinue = false;
        uiCore.showErrorMessage(flowResult.reponse.erreur);
    } else {
        if (flowResult.reponse.dto) {
            me.cmp.replaceElementAtIndex(flowResult.reponse.dto, me.cmp.currentFileIndex);
        }
    }
}
window.mergeMailPj = mergeMailPj;
